import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { URL_EXTENSION } from '@utils/constants/app-constants';
import {
  CreatePlanUnifiedPayload,
  PlanBoDetailed
} from '@utils/types/back-office/update-plan-bo';
import { BaseResponse } from '@utils/types/shared/base';

type CreatePlanUnifiedResponse = BaseResponse<PlanBoDetailed>;

/**
 * Hook to create a plan using the unified endpoint
 * POST /api/v3/admin/plan/unified
 *
 * This endpoint creates plan + price plans + reseller publications in one atomic transaction
 */
export const useCreatePlanUnified = () => {
  const queryClient = useQueryClient();

  const createPlanUnified = async (data: CreatePlanUnifiedPayload) => {
    const response = await Axios.post<CreatePlanUnifiedResponse>(
      `${URL_EXTENSION}/admin/plan/unified`,
      data
    );
    return response.data;
  };

  return useMutation(createPlanUnified, {
    onSuccess: () => {
      // Invalidate both regular and enhanced plan queries
      queryClient.invalidateQueries('plans');
      queryClient.invalidateQueries('plansBo');
      queryClient.invalidateQueries('plansBoEnhanced');
    },
    useErrorBoundary: false
  });
};
